import 'trio-icons/dist/css/trio-icons.css';


// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/trio-icons.js